import type { ValueMeta } from "@/shared/model";

/**
 * Meta 배열 → name(사람의 언어)으로 value(서버와 주고받는 값) 접근하는 상수 객체
 *
 * @example
 * metaToConsts(ERROR_META) → { NETWORK: 'NETWORK_ERROR', AUTH: 'AUTH_FAILED', ... }
 */
export function metaToConsts<M extends ValueMeta<unknown>>(
  metas: readonly M[]
): Record<M["name"], M["value"]> {
  return Object.fromEntries(metas.map((m) => [m.name, m.value])) as Record<M["name"], M["value"]>;
}
